import { Effect, Layer } from "effect";
import { WORKFLOWS_CHANGED_EVENT, WorkflowChangeIo } from "./changes.ts";
export const WorkflowChangeIoLive = Layer.succeed(WorkflowChangeIo, {
  add: listener => Effect.sync(() => { if (typeof window !== "undefined") window.addEventListener(WORKFLOWS_CHANGED_EVENT, listener); }),
  remove: listener => Effect.sync(() => { if (typeof window !== "undefined") window.removeEventListener(WORKFLOWS_CHANGED_EVENT, listener); }),
  publish: workspaceId => Effect.sync(() => { window.dispatchEvent(new CustomEvent(WORKFLOWS_CHANGED_EVENT, { detail: { workspaceId } })); })
});
